import iconeErro from '../img/icone_erro.svg'
import iconeSucesso from '../img/icone_sucesso.svg'

export const ICONE_ERRO = `<img src=${iconeErro} alt="Ícone de erro"/>`

export const ICONE_SUCESSO = `<img src=${iconeSucesso} alt="Ícone de sucesso"/>`

